var exports = {
  "Tp": "x93eb46d8--1949a1--background",
  "KI": "x93eb46d8--1949a1--icon_container",
  "Kk": "x93eb46d8--1949a1--icon",
  "rV": "x93eb46d8--1949a1--click_area",
  "q9": "x93eb46d8--1949a1--click_area--left",
};

module.exports = exports;
